(function () {
    'use strict';

    angular
        .module('garnaCabinet')
        .controller('NavController', NavController);

    NavController.$inject = ['$state', 'localStorageService', 'UserService'];

    /* @ngInject */
    function NavController($state, localStorageService, UserService) {
        var vm = this;
        vm.logout = logout;
        vm.showBackToProjectArrow = showBackToProjectArrow;

        activate();

        ////////////////

        function activate() {
            vm.user = UserService.getUser();
        }

        function logout() {
            localStorageService.remove('token');
            UserService.setUser(null);
            $state.go('auth');
        }

        function showBackToProjectArrow() {
            return !$state.is('project')
        }
    }

})();

